import Config from "@/const/Config";
import { LoginReq, TokenLoginReq } from "@/types/User";
import { BaseApi } from "./BaseApi";

export class AuthApi extends BaseApi {

  /**
   * ログイン
   * @returns 
   */
  public async login(credentials: LoginReq): Promise<boolean> {
    try {
      const res = await this.post(Config.API_URL + '/login', credentials)
      if(res.status !== 200){
        throw new Error("");
      }
      return true
    } catch (e: unknown) {
      console.error('auth error: ', e)
      throw e
    }
  }
  /**
   * XSRF-TOKENクッキーをX-XSRF-TOKENヘッダとして渡し、Laravel SanctumでCSRF保護を初期化します
   * @returns 
   */
  public async sanctum(): Promise<boolean> {
    try {
      const res = await this.get(Config.APP_URL + '/sanctum/csrf-cookie')
      return true
    } catch (e: unknown) {
      console.error('sanctum error: ', e)
      throw e
    }
  }

  /**
   * トークンによるログイン
   */
  public async tokenLogin(req: TokenLoginReq): Promise<boolean> {
    try {
      await this.post<boolean>(Config.API_URL + '/token_login', req)
      return true
    } catch (e: unknown) {
      throw e
    }
  }
}